import React, { useState } from 'react';
import styles from './ManualEntry.module.css';

interface ManualEntryProps {
  onLookup: (barcode: string) => void;
}

export const ManualEntry: React.FC<ManualEntryProps> = ({ onLookup }) => {
  const [barcode, setBarcode] = useState('');

  const handleLookup = () => {
    if (barcode.trim()) {
      onLookup(barcode.trim());
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleLookup();
    }
  };

  return (
    <div className={styles.card}>
      <input
        className={styles.input}
        type="text"
        placeholder="Enter UPC/ Barcode Number"
        value={barcode}
        onChange={(e) => setBarcode(e.target.value)}
        onKeyDown={handleKeyDown}
      />
      <button className={styles.button} onClick={handleLookup}>
        Look up
      </button>
    </div>
  );
};
